import commonNav from '@/components/common-nav/index.vue';
import commonModal from '@/components/common-modal/index.vue';
import common from '@/util/common';
import {
	createNamespacedHelpers
} from 'vuex';
const sroreName = {
	cardList: 'cardList',
};
const {
	mapState,
	mapActions,
} = createNamespacedHelpers(sroreName.cardList);
export default {
	data() {
		return {
			modalType: '',
			modalTitle: '',
			modelSubTitle: '',
			isModalShow: false,
			modelInputType: 'text',
			selectAccountNo: '',
			cardList: [],
			getConfigInfo: null,
			bindFlag: '',
			placeholderText: '',
			bindCardParam: {}
		};
	},
	async mounted() {
		this.getConfigInfo = JSON.parse(sessionStorage.getItem('configInfo'));
		const getCardData = await this.postGetCard({
			content: this
		});
		this.cardList = getCardData.data;
	},
	components: {
		'common-nav': commonNav,
		'common-modal': commonModal,
	},
	watch: {
	
	},
	computed: {
		...mapState({
			
		})
	},
	methods: {
		...mapActions({
			postGetCard: 'postGetCard',
			postBindCard: 'postBindCard'
		}),
		goMyInfoHandle(data){
			const configInfo = {
				...this.getConfigInfo,
				AccountNo: data.AccountNo,
			};
			sessionStorage.setItem('configInfo',JSON.stringify(configInfo));
			const target = this.$refs[`card${data.cardNo}`][0];
			common.jumpPage(this, target);
		},
		openModalHandle(type,item){
			if(type === 1){
				//解绑
				this.modalType = 'loss';
				this.modalTitle = '您确定要解绑吗？';
				this.bindCardParam = {
					cardNo: item.cardNo,
					bindFlag: type
				};
			}else if(type === 0){
				//绑定
				this.modalType = 'uncoupling';
				this.modalTitle = '绑定校园卡';
				this.placeholderText = '请输入学生卡号';
				this.modelInputType = 'text';
				this.bindCardParam = {
					bindFlag: type
				};
			}
			this.bindFlag = type;
			this.isModalShow = true;
			
		},
		async modalSure(data){
			if(this.bindFlag === 0){
				this.bindCardParam.cardNo = data?data.password : '';
			}
			const param = {
				content: this,
				data: this.bindCardParam
			};
			const getBindCardData = await this.postBindCard(param);
			this.isModalShow = false;
			if(getBindCardData && getBindCardData.code == 1){
				console.log(getBindCardData);
				this.cardList = getBindCardData.data?getBindCardData.data : [];
			}
		}
	}
}